import { Button } from '@material-tailwind/react';
import UpRightImg from '../assets/img/up_right.svg';
import ClipboardImg from '../assets/img/clipboard.svg'
import { reducedAddress, copyText } from '../utils/utils';
import AuditIcon from '../assets/icons/Audit.svg'

export default function ClaimComponent(props) {
    const { item } = props;
    return (
        <div className='bg-[#121212] w-full px-4 sm:px-[20px] 2xl:px-[140px] pb-[12px] sm:pb-[16px]'>
            <div className='xl:hidden w-full bg-[#1B1B1B] rounded-[16px] px-4 py-4'>
                <div className='flex items-center'>
                    <img src={item.token.icon} alt='ico' className='w-8 h-8' />
                    <div className='ml-3'>
                        <p className='text-white text-[16px]'>{item.token.symbol}</p>
                        <p className='text-[#86888C] text-[13px]'>{item.token.chain}</p>
                    </div>
                </div>
                <div className='mt-4 grid grid-cols-2 gap-3 text-[13px]'>
                    <div>
                        <p className='text-[#86888C] uppercase'>Amount</p>
                        <p className='text-white mt-1'>{item.amount.value}</p>
                        <p className='text-[#86888C]'>{item.amount.price}</p>
                    </div>
                    <div>
                        <p className='text-[#86888C] uppercase'>Allocated</p>
                        <p className='text-white mt-1'>{item.allocatedAmount.state}</p>
                        <p className='text-[#86888C]'>{item.allocatedAmount.value}</p>
                    </div>
                    <div>
                        <p className='text-[#86888C] uppercase'>Percentage</p>
                        <p className='text-white mt-1'>{item.percentage.precent}</p>
                    </div>
                    <div>
                        <p className='text-[#86888C] uppercase'>Token ID</p>
                        <p className='text-white mt-1'>{reducedAddress(item.tokenId)}</p>
                    </div>
                </div>
                <div className='flex items-center justify-between mt-4 pt-3 border-t border-[#2C2C2C]'>
                    <img src={AuditIcon} alt='audit' className='h-6' />
                    <Button
                        className='w-[38px] h-[40px] rounded-[6px] border border-[#2C2C2C] flex items-center justify-center p-[12px]'
                        onClick={() => copyText(item.tokenId)}
                    >
                        <img src={ClipboardImg} alt='copy' className='w-[13px] h-[16px]' />
                    </Button>
                </div>
            </div>

            <div className='hidden xl:flex flex-row items-center justify-between w-full bg-[#1B1B1B] rounded-[16px] px-[40px] py-[20px]'>
                <div className='flex flex-row basis-2/12'>
                    <img src={item.token.icon} alt='ico' />
                    <div className='flex flex-col ml-[12px]'>
                        <p className='font-Inter-Regular text-[16px] text-[#FFF]'>
                            {item.token.symbol}
                        </p>
                        <p className='font-Inter-Regular text-[14px] text-[#86888C]'>
                            {item.token.chain}
                        </p>
                    </div>
                </div>

                <div className='flex flex-col basis-2/12'>
                    <p className='font-Inter-Regular text-[16px] text-[#FFF]'>{item.amount.value}</p>
                    <p className='font-Inter-Regular text-[16px] text-[#FFF]'>{item.amount.price}</p>
                </div>

                <div className='flex flex-col basis-2/12'>
                    <p className='font-Inter-Regular text-[16px] text-[#FFF]'>{item.allocatedAmount.state}</p>
                    <p className='font-Inter-Regular text-[16px] text-[#FFF]'>{item.allocatedAmount.value}</p>
                </div>

                <div className='flex flex-col basis-2/12'>
                    <p className='font-Inter-Regular text-[14px] text-[#86888C] font-bold'>{item.percentage.state}</p>
                    <p className='font-Inter-Regular text-[14px] text-[#86888C]'>{item.percentage.precent}</p>
                </div>

                <div className='flex flex-row h-full items-center justify-between basis-2/12'>
                    <div className='flex flex-row items-center'>
                        <p className='font-Inter-Regular text-[16px] text-[#FFF] mr-[6px]'>
                            {reducedAddress(item.tokenId)}
                        </p>
                        <img src={UpRightImg} alt='ico' />
                        <Button
                            className='w-[38px] h-[40px] rounded-[6px] border-[1px] border-[#2C2C2C] flex items-center justify-center p-[12px] ml-[23px]'
                            onClick={() => copyText(item.tokenId)}
                        >
                            <img src={ClipboardImg} alt='ico' className='w-[13px] h-[16px]' />
                        </Button>
                    </div>
                </div>
                <div className='flex flex-row justify-center items-center basis-2/12'>
                    <img src={AuditIcon} alt='ico' />
                </div>
            </div>
        </div>
    )
}
